<template>
  <AppToggleDropdown
    trigger-classes="btn btn-icon btn-naked"
    title="Table Columns"
    :tooltip-options="{ placement: 'left' }"
  >
    <template #trigger>
      <i class="hi hi-columns hi-16" />
    </template>
    <AppColumnToggle
      active
      disabled
    >
      {{ $filters.projectFlavourLabel(projectFlavour) }}
    </AppColumnToggle>
    <AppColumnToggle
      v-if="reasonsOrNotesArePresent"
      column="show_reasons"
      :active="columns.show_reasons"
      @change="handleChange"
    >
      Reason
    </AppColumnToggle>
    <AppColumnToggle
      column="show_activity"
      :active="columns.show_activity"
      @change="handleChange"
    >
      Activity
    </AppColumnToggle>
    <AppColumnToggle
      column="show_idle"
      :active="columns.show_idle"
      @change="handleChange"
    >
      Idle
    </AppColumnToggle>
    <AppColumnToggle
      active
      disabled
    >
      Manual
    </AppColumnToggle>
    <AppColumnToggle
      active
      disabled
    >
      Duration
    </AppColumnToggle>
    <AppColumnToggle
      column="show_source"
      :active="columns.show_source"
      @change="handleChange"
    >
      Source
    </AppColumnToggle>
    <AppColumnToggle
      active
      disabled
    >
      Time
    </AppColumnToggle>
    <AppColumnToggle
      v-if="canShowScreenshotsColumn"
      column="show_screenshots"
      :active="columns.show_screenshots"
      @change="handleChange"
    >
      Screenshots
    </AppColumnToggle>
    <AppColumnToggle
      active
      disabled
    >
      Actions
    </AppColumnToggle>
  </AppToggleDropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import AppColumnToggle from '../AppColumnToggle.vue';
import AppToggleDropdown from '../AppToggleDropdown.vue';

export default {
  name: 'TimeEntriesColumnPicker',
  components: { AppColumnToggle, AppToggleDropdown },
  props: {
    columns: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['change'],
  computed: {
    ...mapGetters(['projectFlavour', 'canShowScreenshotsColumn', 'reasonsOrNotesArePresent']),
  },
  methods: {
    handleChange(payload) {
      this.$emit('change', { ...this.columns, ...payload });
    },
  },
};
</script>
